import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Shell } from "@/lib/editorial";
import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/lib/api";

import Login from "@/pages/Login";
import AgentsList from "@/pages/AgentsList";
import AgentDetail from "@/pages/AgentDetail";
import AgentContacts from "@/pages/AgentContacts";
import AgentTemplates from "@/pages/AgentTemplates";
import NewAgent from "@/pages/NewAgent";
import Settings from "@/pages/Settings";
import HowItWorks from "@/pages/HowItWorks";
import Inbox from "@/pages/Inbox";
import Blitz from "@/pages/Blitz";
import Discovery from "@/pages/Discovery";
import PostingHub from "@/pages/PostingHub";
import KnowledgeBase from "@/pages/KnowledgeBase";

function RequireAuth({ children }) {
  const { data, isLoading } = useQuery({
    queryKey: ["auth-check"],
    queryFn: authApi.check,
    retry: false,
    staleTime: 60_000,
  });
  if (isLoading) return null; // blank while checking — avoids flash
  if (!data?.authed) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <Shell>
                <Routes>
                  <Route path="/" element={<Navigate to="/admin/agents" replace />} />
                  <Route path="/admin" element={<Navigate to="/admin/agents" replace />} />
                  <Route path="/admin/agents" element={<AgentsList />} />
                  <Route path="/admin/agents/new" element={<NewAgent />} />
                  <Route path="/admin/agents/:id" element={<AgentDetail />} />
                  <Route path="/admin/agents/:id/contacts" element={<AgentContacts />} />
                  <Route path="/admin/agents/:id/templates" element={<AgentTemplates />} />
                  <Route path="/admin/settings" element={<Settings />} />
                  <Route path="/admin/info" element={<HowItWorks />} />
                  <Route path="/admin/inbox" element={<Inbox />} />
                  <Route path="/admin/inbox/:contactId" element={<Inbox />} />
                  <Route path="/admin/blitz" element={<Blitz />} />
                  <Route path="/admin/discover" element={<Discovery />} />
                  <Route path="/admin/posts" element={<PostingHub />} />
                  <Route path="/admin/knowledge" element={<KnowledgeBase />} />
                  <Route path="*" element={<Navigate to="/admin/agents" replace />} />
                </Routes>
              </Shell>
            </RequireAuth>
          }
        />
      </Routes>
      <Toaster position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
